const universities = (state) => {
  return state.universities;
}

const universityNameFilterWithAll = (state) => {
  var university_filter = [];

  for (var i = 0; i < state.universities.length; i++) {
    university_filter.push(state.universities[i].name);
  }

  return university_filter;
}

const university = (state) => {
  return state.university;
}

const getUniversityByName = (state) => (name) => {
  return state.universities.find(university => university.name === name);
}

export default {
  universities,
  universityNameFilterWithAll,
  university,
  getUniversityByName,
}